import { render, staticRenderFns } from "./MinArticleStock.vue?vue&type=template&id=af7b6756&scoped=true"
import script from "./MinArticleStock.vue?vue&type=script&lang=js"
export * from "./MinArticleStock.vue?vue&type=script&lang=js"
import style0 from "./MinArticleStock.vue?vue&type=style&index=0&id=af7b6756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7b6756",
  null
  
)

export default component.exports